import { useHistory, useParams, useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import TemplateNamePopup from "./TemplateNamePopup";
import Header from "../../layouts/Header";
import { Button, Col, Row } from "react-bootstrap";
import PlusIcon from "../../assets/icons/Plus.svg";
import MobileIcon from "../../assets/icons/TemplateBuilder/mobile.svg";
import DesktopIcon from "../../assets/icons/TemplateBuilder/desktop.svg";
import TemplateOutput from "./TemplateOutput";
import { useSelector, useDispatch } from "react-redux";

import {
  availabaleFields,
  addNewEmailTemplate,
  addNewCheckListTemplate,
  addNewOthersTemplate,
  addNewInvoiceTemplate,
  addNewQuotesTemplate,
  addNewStockTemplate,
  getTemplateForEditById,
  EditTemplate,
} from "../../redux/actions/action";
import GrapesTemplateEditor from "./GrapesTemplateEditor";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const SYSTEM_TEMPLATE_FIELDS = [
  {
    fieldId: "__system_line__",
    fieldName: "Line",
    fieldPlaceHolder: "{LINE}",
    isSystemField: true,
  },
  {
    fieldId: "__system_today_date__",
    fieldName: "Today Date",
    fieldPlaceHolder: "{TODAY_DATE}",
    isSystemField: true,
  },
];

const GenericTemplateBuilder = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const location = useLocation();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Template-Builder-Add-Edit").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [showTemplateNamePopup, setShowTemplateNamePopup] = useState(
    id ? false : true,
  );
  const [templateName, setTemplateName] = useState("");
  const [templateType, setTemplateType] = useState("");
  const availableFields = useSelector((data) => data.user.availableFields);
  const [availableTemplateFields, setAvailableTemplateFields] = useState([]);
  const [templateOutput, setTemplateOutput] = useState("PDF");
  const [screenSizeOption, setScreenSizeOption] = useState(false);
  const [initialTemplateContent, setInitialTemplateContent] = useState(null);
  const [editorReady, setEditorReady] = useState(false);

  const [desktopScreen, setDesktopScreen] = useState(true);
  const editorRef = useRef(null);

  const handleCancel = () => {
    setShowTemplateNamePopup(false);
    history.goBack();
  };

  const addTemplateName = (value) => {
    setShowTemplateNamePopup(false);
    setTemplateName(value);
  };

  const notImplementedAction = () => {
    alert("Not Implementetd");
  };

  useEffect(() => {
    if (id) {
      // edit Operations
      dispatch(availabaleFields()); // change this api in future to show available fields based on what was used in template and what is available to use
      getTemplateForEdit();
    } else {
      dispatch(availabaleFields());
    }
  }, []);

  const getTemplateForEdit = () => {
    getTemplateForEditById(id).then((o) => {
      if (o && o.data && o.data.status) {
        setInitialTemplateContent(o.data.data.templateContent);
        setTemplateName(o.data.data.templateName);
        setTemplateOutput(o.data.data.outputType);
      }
    });
  };

  useEffect(() => {
    if (availableFields && availableFields.status) {
      const fieldList = Array.isArray(availableFields.data)
        ? [...availableFields.data]
        : [];
      SYSTEM_TEMPLATE_FIELDS.forEach((systemField) => {
        if (
          !fieldList.some(
            (x) => x.fieldPlaceHolder === systemField.fieldPlaceHolder,
          )
        ) {
          fieldList.push(systemField);
        }
      });
      setAvailableTemplateFields(fieldList);
    }
  }, [availableFields]);

  useEffect(() => {
    if (location.pathname.includes("/invoice-builder"))
      setTemplateType("Invoices-");
    else if (location.pathname.includes("/stock-builder"))
      setTemplateType("Stocks-");
    else if (location.pathname.includes("/quote-builder"))
      setTemplateType("Quotes-");
    else if (location.pathname.includes("/email-builder")) {
      setScreenSizeOption(true);
      setTemplateType("Email-");
    } else if (location.pathname.includes("/checklist-builder")) {
      setTemplateType("Checklist-");
    } else if (location.pathname.includes("/others-builder")) {
      setTemplateType("Others-");
    }
  }, [location]);

  const addUpdateTemplate = () => {
    if (!editorReady || !editorRef.current) {
      alert("The template editor is still loading. Please try again.");
      return;
    }
    if (id) {
      handleEdit().then((o) => {
        history.goBack();
      });
    } else {
      handleAdd().then((o) => {
        history.goBack();
      });
    }
  };

  const handleAdd = () => {
    const templateContent = editorRef.current.getTemplateContent();
    const data = {
      templateName: templateName,
      templateContent: JSON.stringify(templateContent),
      outputType: templateOutput,
    };

    if (location.pathname === "/invoice-builder")
      return addNewInvoiceTemplate(data);
    else if (location.pathname === "/stock-builder")
      return addNewStockTemplate(data);
    else if (location.pathname === "/quote-builder")
      return addNewQuotesTemplate(data);
    else if (location.pathname === "/email-builder")
      return addNewEmailTemplate(data);
    else if (location.pathname === "/checklist-builder")
      return addNewCheckListTemplate(data);
    else if (location.pathname === "/others-builder")
      return addNewOthersTemplate(data);
  };

  const handleEdit = () => {
    const templateContent = editorRef.current.getTemplateContent();
    const data = {
      templateName: templateName,
      templateContent: JSON.stringify(templateContent),
      outputType: templateOutput,
    };

    if (location.pathname.includes("/invoice-builder"))
      return EditTemplate(id, data);
    else if (location.pathname.includes("/stock-builder"))
      return EditTemplate(id, data);
    else if (location.pathname.includes("/quote-builder"))
      return EditTemplate(id, data);
    else if (location.pathname.includes("/email-builder"))
      return EditTemplate(id, data);
    else if (location.pathname.includes("/checklist-builder"))
      return EditTemplate(id, data);
    else if (location.pathname.includes("/others-builder"))
      return EditTemplate(id, data);
  };

  const changeOutput = (output) => {
    setTemplateOutput(output);
  };

  return (
    <>
      {/* Header Section for path display */}
      <Header
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/settings");
              }}
            >
              {/* Settings */}
              {t("Settings ")}
            </div>
            <p className="products-and-parts-sub-title">
              {id ? (
                <label>
                  <label style={{ color: "lightgrey" }}>
                    {templateType}Edit |
                  </label>
                  &nbsp;<strong>{templateName}</strong>
                </label>
              ) : (
                <label>
                  <label style={{ color: "lightgrey" }}>
                    {templateType}Add New |
                  </label>
                  &nbsp;<strong>{templateName}</strong>
                </label>
              )}
            </p>
          </div>
        }
      />

      {/* Main action Button */}
      <div className="ps-4 pe-5">
        <Row>
          <Col xl={3}>
            {/* <div className='ps-3' style={{ fontSize: "14px", cursor: "pointer" }} onClick={notImplementedAction}>
                            <img src={PlusIcon} className="" alt="Add Icon" />&nbsp;&nbsp;&nbsp;Upload File
                        </div> */}
          </Col>
          <Col xl={6}>
            <TemplateOutput
              output={templateOutput}
              handleChange={changeOutput}
            />
          </Col>
          <Col xl={3} className="add-col-item ">
            <button
              className="template-action-btn cancel p-2"
              onClick={handleCancel}
            >
              {/* Cancel */}
              {t("Cancel ")}
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button
              className="template-action-btn add p-2"
              onClick={addUpdateTemplate}
            >
              {/* {id ? 'Edit' : 'Add'} */}
              {id ? t("Edit ") : t("Add")}
            </button>
          </Col>
        </Row>

        <Row className="mt-4">
            {screenSizeOption && (
              <Col xl={1}>
                <div style={{ fontSize: "14px" }} className="ps-3">
                  <Row
                    className={
                      desktopScreen
                        ? "device-selection mt-5 mb-4"
                        : "device-selection mt-5 mb-4 disable"
                    }
                    onClick={() => {
                      setDesktopScreen(true);
                    }}
                  >
                    <Col xl={3} className="d-flex justify-content-center">
                      <img
                        src={DesktopIcon}
                        className=""
                        alt="Desktop Screen"
                      />
                    </Col>
                    <Col>
                      {/* Desktop */}
                      {t("Desktop")}
                    </Col>
                  </Row>
                  <Row
                    className={
                      desktopScreen
                        ? "device-selection disable"
                        : "device-selection"
                    }
                    onClick={() => {
                      setDesktopScreen(false);
                    }}
                  >
                    <Col xl={3} className="d-flex justify-content-center">
                      <img src={MobileIcon} className="" alt="Mobile Screen" />
                    </Col>
                    <Col>
                      {/* Mobile */}
                      {t("Mobile")}
                    </Col>
                  </Row>
                </div>
              </Col>
            )}
            <Col xl={11}>
              <div
                style={{
                  background: "#FFF",
                  minHeight: "70vh",
                  marginBottom: "20px",
                }}
              >
                <GrapesTemplateEditor
                  ref={editorRef}
                  availableFields={availableTemplateFields}
                  initialContent={initialTemplateContent}
                  desktopScreen={desktopScreen}
                  templateKind={templateType}
                  onReady={setEditorReady}
                />
              </div>
            </Col>
          </Row>
      </div>
      <TemplateNamePopup
        handleCancel={handleCancel}
        handleAddName={addTemplateName}
        animation={true}
        show={showTemplateNamePopup}
      />
    </>
  );
};

export default GenericTemplateBuilder;
